<p-toast></p-toast>

<!-- Testing and Development Assets -->
<!--<button (click)="testCreateTenantMapping();">Create Tenant Mapping</button>-->
<!--<button (click)="testGetTenantMapping();">Get Tenant Mapping</button>-->
<!--<button (click)=" testReloadOpenInvoices();">Reload Invoices</button>-->
<!--<button (click)="testSimulateError();">Simulate Error</button>-->
<!--<button (click)="testGetTime();">Test Get Time</button>-->
<!--<button (click)="testGetLID();">Get LID</button>-->

<div class="grid p-fluid py-5">


    <div class="col-12 flex justify-content-center align-item-center">
        <div class="card flex gap-2">
            <a pButton [href]="'/portal'" class="no-underline w-auto" severity="primary" label="Back to Portal"></a>
            <p-fileUpload
                mode="basic"
                chooseLabel="Import Sheet"
                chooseIcon="pi pi-upload"
                name="invoiceFile[]"
                [accept]="supportedMimeTypes"
                (onSelect)="importInvoiceSheet($event)"
                (onClear)="clearInvoiceSheetSeletion()"
                [multiple]="true"
                [showCancelButton]="true"
                #invoiceSheetFileUpload/>
            <p-button severity="primary" label="Clear" (onClick)="invoiceSheetFileUpload.clear()" *ngIf="invoiceSheetFileUpload?.files?.length"/>
        </div>
    </div>
    <div class="col-12 flex justify-content-center align-item-center">
        <p-messages class="w-full lg:w-6"/>
    </div>
    <div class="col-12 flex justify-content-center align-item-center" *ngIf="invoiceSheetFileUpload?.files?.length">
        <div class="card">
            <div *ngIf="loading else loadTable">
                <p-progressSpinner ariaLabel="loading" />
            </div>
            <ng-template #loadTable>
                <form [formGroup]="tenantsForm">
                    <div formArrayName="tenants">
                        <p-table [value]="tableData" [columns]="columnNames" rowGroupMode="subheader"
                            groupRowsBy="merchant_index" [tableStyle]="{'min-width': '60rem'}">
                            <ng-template pTemplate="caption">
                                <div class="flex flex-wrap justify-content-end gap-2">
                                    <p-button severity="success" label="Create Invoice" (onClick)="checkValidationAndShowPopup()" [loading]="invoiceInProgress"/>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th *ngFor="let column of columns">{{column.header}}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="groupheader" let-customer let-columns="columns">
                                <tr pRowGroupHeader>
                                    <td [attr.colspan]="columns.length - 4">
                                        <span class="font-bold ml-2">{{customer.merchant_account}}</span>
                                        <div *ngIf="getTenantFormGroup(customer.merchant_index).controls['merchant_name'].errors">
                                            <div class="ui-messages-error ml-2"
                                                         *ngIf="getTenantFormGroup(customer.merchant_index).controls['merchant_name'].errors?.['validationNotFound']">This marchant wont get invoice due to following validation(s) not found.
                                                         <span *ngFor="let validation of getTenantFormGroup(customer.merchant_index).controls['merchant_name'].errors?.['validationNotFound']; let i = index">
                                                            <br> {{i+1}}. {{validation}}
                                                         </span>
                                                         <br>
                                                         Please fix before generate invoice.
                                                    </div>
                                        </div>
                                    </td>
                                    <td colspan="2">
                                        <div [formGroup]="getTenantFormGroup(customer.merchant_index)">
                                            <input type="text" pInputText formControlName="comments" placeholder="Comments" />
                                        </div>
                                    </td>
                                    <td colspan="2">
                                            <div [formGroup]="getTenantFormGroup(customer.merchant_index)">
                                                <p-autoComplete  placeholder="Search Tenants"
                                                formControlName="tenant"
                                                [forceSelection]="true" [completeOnFocus]="true"
                                                [suggestions]="filteredTenants" [field]="$any(getSelectedTenantName)"
                                                (completeMethod)="filterTenant($event)"
                                                [showClear]="true"
                                                appendTo="body">
                                                <ng-template let-tenent pTemplate="item">
                                                    <div class="flex align-items-center gap-2">
                                                        <div>{{ tenent.suite }} - {{ tenent.account }}</div>
                                                        <div>{{ tenent.name }} ({{ tenent.billto }})</div>
                                                    </div>
                                                </ng-template>
                                                </p-autoComplete>
                                                <div *ngIf="tenantFormSubmitted && getTenantFormGroup(customer.merchant_index).controls['tenant'].errors && !getTenantFormGroup(customer.merchant_index).controls['merchant_name'].errors?.['validationNotFound']">
                                                    <div class="ui-messages-error"
                                                         *ngIf="getTenantFormGroup(customer.merchant_index).controls['tenant'].errors?.['required']">Please select tenant.
                                                    </div>
                                                  </div>
                                            </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-customer let-rowIndex="rowIndex" let-columns="columns">
                                <tr>
                                    <td *ngFor="let col of columns">
                                        <div *ngIf="col.field != columnGroup?.id">
                                            {{customer[col.field]}}
                                            <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem" *ngIf="invoiceInProgress && col.field == 'invoice_id' && !customer[col.field]"></i>
                                        </div>
                                        <div class="flex" *ngIf="col.field == columnGroup?.id">
                                            <div class="m-auto">{{customer[col.field]['summary']}}</div>
                                            <p-button  *ngIf="col.field == columnGroup?.id"
                                            [pTooltip]="customer[col.field]['desciption']"  icon="pi pi-info-circle" tooltipposition="bottom"
                                            [tooltipOptions]="{'appendTo': 'body'}"
                                            [rounded]="true" [text]="true"
                                            ></p-button>
                                        </div>

                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </form>
                <p-dialog header="Edit missing validation type" [modal]="true" [(visible)]="showValidationSelectionPopup" [style]="{ width: '40rem' }"
                 [draggable]="false" [resizable]="false">
                    <div *ngFor="let validation of ValidationsFormControlArray.controls; let i = index" [formGroup]="getValidationsFormGroup(i)" class="mb-4 col">
                        <label>{{ getValidationsFormGroup(i).value['validation'] }}</label>
                        <p-dropdown [options]="listDescriptions" formControlName="updated_validation" optionLabel="description" placeholder="Select item type" appendTo="body"
                        [showClear]="true"/>
                        <div *ngIf="validationsFormSubmitted && getValidationsFormGroup(i).controls['updated_validation'].errors">
                            <div class="ui-messages-error"
                                 *ngIf="getValidationsFormGroup(i).controls['updated_validation'].errors?.['required']">Please select validation.
                            </div>
                          </div>
                    </div>

                    <ng-template pTemplate="footer">
                        <div class="flex gap-2">
                            <p-button label="Only Invoice Merchants With Matched Rates" severity="secondary" (onClick)="createInvoice()" />
                            <p-button label="Use Specified Rates and Create Invoices" (onClick)="updateValidations()" />
                        </div>
                    </ng-template>
                </p-dialog>
            </ng-template>
        </div>
    </div>
</div>

<div class="footer-version">Version: {{version}} {{activeFile}}</div>
